<template>
  <div class="ms-form">
    <q-form @submit="this.onSubmit">
      <div class="ms-form-grid">
        <CustomInput
            class="ms-form-wide"
            label="Комментарий"
            type="text"
            :required="true"
            :value="this.formData.comment"
            @change_input="(value) => onChange('comment', value)"
        />
        <CustomSelect
            :options="this.steps"
            label="Шаг"
            :required="true"
            :disabled="!!this.data?.lockStep"
            optionValueKey="step_id"
            optionLabelKey="step_name"
            :value="this.formData.step_id || ''"
            @change="(value) => onChange('step_id', value)"
        />
        <CustomSelect
            :options="this.types"
            label="Тип"
            :required="true"
            optionValueKey="condition_type_id"
            optionLabelKey="type_name"
            :value="this.formData.condition_type_id || ''"
            @change="(value) => onChange('condition_type_id', value)"
        />
        <CustomInput
            label="Значение"
            :required="true"
            :value="this.formData.param_value"
            @change_input="(value) => onChange('param_value', value)"
        />
        <div class="step-cond__active">
          <CustomCheckbox
              color="primary"
              label="Активный"
              :value="!!this.formData.is_active"
              @change="value => onChange('is_active', value)"
          />
        </div>
        <JsonEditor
            class="ms-form-wide"
            label="Параметры (json)"
            :rows="6"
            :value="this.formData.param_json"
            @change_input="(value) => onChange('param_json', value)"
        />
      </div>
      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomSelect from "@/components/form/CustomSelect";
import {getStepConditionTypes, getTimelineSteps} from "@/views/handbook/timlineStepConditions/services";
import CustomCheckbox from "@/components/form/CustomCheckbox";
import JsonEditor from "@/components/form/JsonEditor";

export default {
  name: "add-step-include-cond",
  components: {CustomCheckbox, CustomSelect, CustomInput, CustomModalFooter, JsonEditor},
  props: ['data'],
  data() {
    return {
      loading: false,
      steps: [],
      types: [],
      formData: {
        condition_type_id: this.data?.body?.condition_type_id || '',
        step_id: this.data?.body?.step_id || '',
        param_json: this.data?.body?.param_json || '',
        param_value: this.data?.body?.param_value || '',
        comment: this.data?.body?.comment || '',
        is_active: !!this.data?.body?.is_active,
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      this.loading = true
      await this.data?.onSubmit(this.formData)
      this.loading = false
    },
    async fetchSteps() {
      const res = await getTimelineSteps()
      this.steps = res || []
    },
    async fetchConditionTypes() {
      const res = await getStepConditionTypes()
      this.types = res || []
    },
  },
  mounted() {
    this.fetchSteps()
    this.fetchConditionTypes()
  }
}
</script>

<style scoped lang="scss">
// Сетка — общая (ms-form-* в theme.scss)
// «Активный» — по нижнему краю соседнего поля «Значение»
.step-cond__active {
  align-self: end;
}
</style>
